import ActivityTypeTag from "../../../elements/ActivityTypeTag";
import styled from "styled-components";

export default styled(ActivityTypeTag)`
  position: absolute;
  bottom: 10px;
  left: 10px;
`;
